import { ROUTES } from "../../../common/constants/routes.const";

/**
 * Create CTA clicked event data for entity management actions
 * @param {string} ctaText - The text of the CTA button
 * @param {string} ctaLocation - The location of the CTA button
 * @param {string} ctaType - The type of CTA (button, link, etc.)
 * @returns {Object} Event data for CTA click
 */
export const createEntityManagementCTAClickEvent = (ctaText, ctaLocation, ctaType = 'button') => {
  return {
    cta_text: ctaText,
    cta_location: ctaLocation,
    cta_type: ctaType,
    source_url: window.location.href,
    destination_url: window.location.href,
  };
};

/**
 * Create "Go to Filter" CTA clicked event data
 * @param {string} entityName - The name of the entity
 * @param {string} entityType - The type of the entity
 * @returns {Object} Event data for "Go to Filter" click
 */
export const createGoToFilterCTAClickEvent = (entityName, entityType) => {
  return {
    cta_text: 'Go to Filter',
    cta_location: 'Entities Right Pane',
    cta_type: 'button',
    source_url: window.location.href,
    destination_url: ROUTES.wealthOverview.url,
    entity_name: entityName,
    entity_type: entityType,
  };
}; 